<template>
  <div class="pagination">
    <button
      class="pagination-btn"
      :disabled="page === 1"
      @click="$emit('previous')"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
    </button>
    <button
      v-for="pageNum in visiblePages"
      :key="pageNum"
      class="pagination-btn"
      :class="{ active: pageNum === page }"
      :disabled="pageNum === '...'"
      @click="pageNum !== '...' && $emit('goto', pageNum)"
    >
      {{ pageNum }}
    </button>
    <button class="pagination-btn" :disabled="!hasMore" @click="$emit('next')">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    hasMore: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    visiblePages() {
      const pages = []
      const total = this.lastPage
      const current = this.page

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        pages.push(1)

        if (current > 3) {
          pages.push('...')
        }

        const start = Math.max(2, current - 1)
        const end = Math.min(total - 1, current + 1)

        for (let i = start; i <= end; i++) {
          pages.push(i)
        }

        if (current < total - 2) {
          pages.push('...')
        }

        pages.push(total)
      }

      return pages
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 24px 0;
  margin-top: 16px;
}

.pagination-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $ipWhite;
  border: 1px solid $ipGreyLighter;
  border-radius: 8px;
  color: $ipGreyDark;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: $ipGreyDark;
    color: $ipBlack;
  }

  &.active {
    background: $ipGreen;
    border-color: $ipGreen;
    color: $ipWhite;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
